import { queryOptions } from '@tanstack/react-query';
import { companyKeys } from '@shared/api/query-keys';
import type { GetCompanyParams } from '@api/types/company';
import { companyApi } from './company';

type Id = string | number;

/**
 * Co-located `queryOptions` for the company domain (Server-state rebuild, P4-tail).
 * Note: `detail` keys on id only (params are not part of the cache key — preserved
 * from the legacy QK.company.byId behaviour).
 */
export const companyQueries = {
  detail: (id?: Id, params?: GetCompanyParams) =>
    queryOptions({
      queryKey: companyKeys.detail(id),
      queryFn: () => companyApi.getCompany(id as Id, params),
    }),
  commercialRegister: (id?: Id) =>
    queryOptions({
      queryKey: companyKeys.commercialRegister(id),
      queryFn: () => companyApi.getCommercialRegisterURL(id as Id),
    }),
  zefix: (query: string) =>
    queryOptions({
      queryKey: companyKeys.zefix(query),
      queryFn: ({ signal }) => companyApi.fetchZefixCompanies(query, { signal }),
    }),
  // The platform's vocabulary: it changes only with a deploy.
  legalForms: () =>
    queryOptions({
      queryKey: companyKeys.legalForms(),
      queryFn: () => companyApi.getLegalForms(),
      staleTime: Infinity,
    }),
};
